import { UserCheck, UserCog, BookOpen, Briefcase, CheckSquare, FileSearch, Heart, ShieldCheck } from 'lucide-react';
import { useEffect } from 'react';

const Services = () => {
  useEffect(() => {
    document.title = 'Layanan Kami - CV Samudera Alam Perkasa';
    window.scrollTo(0, 0);
  }, []);

  const mainServices = [
    {
      icon: <UserCheck size={64} className="text-primary-600" />,
      title: 'Rekrutmen Tenaga Kerja',
      description:
        'Kami menyediakan tenaga kerja berkualitas yang sesuai dengan kebutuhan spesifik perusahaan Anda melalui proses seleksi yang ketat.',
      features: [
        'Analisis kebutuhan tenaga kerja',
        'Seleksi kandidat komprehensif',
        'Verifikasi latar belakang',
        'Penilaian keterampilan',
        'Penempatan dan orientasi',
      ],
    },
    {
      icon: <UserCog size={64} className="text-primary-600" />,
      title: 'Manajemen Tenaga Kerja',
      description:
        'Kami mengelola seluruh aspek administratif tenaga kerja termasuk penggajian, kontrak, dan kepatuhan terhadap regulasi ketenagakerjaan.',
      features: [
        'Administrasi kontrak kerja',
        'Pengelolaan penggajian',
        'Kepatuhan regulasi',
        'Evaluasi kinerja',
        'Penanganan masalah tenaga kerja',
      ],
    },
    {
      icon: <BookOpen size={64} className="text-primary-600" />,
      title: 'Pengembangan Keterampilan & Pelatihan',
      description:
        'Program pelatihan komprehensif untuk meningkatkan keterampilan tenaga kerja sesuai dengan standar industri dan kebutuhan perusahaan.',
      features: [
        'Analisis kebutuhan pelatihan',
        'Program pelatihan teknis',
        'Pengembangan soft skills',
        'Sertifikasi keterampilan',
        'Evaluasi pasca pelatihan',
      ],
    },
    {
      icon: <Briefcase size={64} className="text-primary-600" />,
      title: 'Konsultasi SDM',
      description:
        'Layanan konsultasi profesional untuk membantu perusahaan mengoptimalkan strategi pengelolaan sumber daya manusia mereka.',
      features: [
        'Analisis kebutuhan SDM',
        'Pengembangan kebijakan SDM',
        'Strategi retensi karyawan',
        'Audit kepatuhan SDM',
        'Perencanaan suksesi',
      ],
    },
  ];

  const additionalServices = [
    {
      icon: <CheckSquare size={48} className="text-primary-600" />,
      title: 'Verifikasi Latar Belakang',
      description:
        'Layanan pemeriksaan menyeluruh terhadap latar belakang calon tenaga kerja untuk memastikan kredibilitas dan kesesuaian.',
    },
    {
      icon: <FileSearch size={48} className="text-primary-600" />,
      title: 'Evaluasi Kinerja',
      description:
        'Sistem penilaian kinerja terstruktur untuk membantu perusahaan memantau dan meningkatkan produktivitas tenaga kerja.',
    },
    {
      icon: <Heart size={48} className="text-primary-600" />,
      title: 'Program Kesejahteraan',
      description:
        'Rancangan program kesejahteraan untuk meningkatkan kepuasan dan loyalitas tenaga kerja terhadap perusahaan.',
    },
    {
      icon: <ShieldCheck size={48} className="text-primary-600" />,
      title: 'Kepatuhan & Legalitas',
      description:
        'Memastikan semua aspek ketenagakerjaan sesuai dengan regulasi dan peraturan pemerintah yang berlaku.',
    },
  ];

  return (
    <>
      {/* Page Header */}
      <div className="bg-navy-900 text-white py-20 mt-16">
        <div className="container-custom">
          <h1 className="text-4xl font-bold mb-4">Layanan Kami</h1>
          <p className="text-lg text-gray-300 max-w-3xl">
            Kami menawarkan berbagai layanan tenaga kerja komprehensif untuk memenuhi kebutuhan bisnis Anda.
          </p>
        </div>
      </div>

      {/* Main Services */}
      <section className="py-16">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Layanan Utama
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Solusi ketenagakerjaan komprehensif untuk mendukung kebutuhan bisnis Anda.
            </p>
          </div>

          <div className="space-y-16">
            {mainServices.map((service, index) => (
              <div 
                key={index} 
                className={`flex flex-col ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'
                } gap-12 items-center`}
              >
                <div className="lg:w-1/2">
                  <div className="text-center lg:text-left">
                    <div className="inline-block mb-4">{service.icon}</div>
                    <h3 className="text-2xl font-bold mb-4 text-navy-900">{service.title}</h3>
                    <p className="text-gray-600 mb-6">{service.description}</p>
                    
                    <ul className="space-y-3 text-left">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <span className="text-primary-600 mr-2">✓</span>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                
                <div className="lg:w-1/2">
                  <img
                    src={`https://images.pexels.com/photos/${3000 + index}/pexels-photo-${3000 + index}.jpeg?auto=compress&cs=tinysrgb&w=1600`}
                    alt={service.title}
                    className="rounded-lg shadow-lg w-full h-auto"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Layanan Tambahan
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Layanan pendukung untuk melengkapi kebutuhan manajemen tenaga kerja Anda.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {additionalServices.map((service, index) => (
              <div key={index} className="card p-6 text-center hover:translate-y-[-8px]">
                <div className="inline-block mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-3 text-navy-900">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Process */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
              Proses Layanan Kami
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
              Bagaimana kami bekerja untuk memenuhi kebutuhan tenaga kerja perusahaan Anda.
            </p>
          </div>

          <div className="max-w-5xl mx-auto">
            <div className="relative">
              {/* Process Steps */}
              <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-1 bg-primary-600 transform -translate-x-1/2"></div>
              
              <div className="space-y-12 md:space-y-0">
                {[
                  {
                    number: '01',
                    title: 'Konsultasi Awal',
                    description: 'Kami menganalisis kebutuhan tenaga kerja spesifik perusahaan Anda.',
                  },
                  {
                    number: '02',
                    title: 'Penyusunan Strategi',
                    description: 'Kami merancang strategi rekrutmen dan manajemen yang sesuai dengan kebutuhan Anda.',
                  },
                  {
                    number: '03',
                    title: 'Implementasi',
                    description: 'Menjalankan proses rekrutmen, seleksi, dan penempatan tenaga kerja.',
                  },
                  {
                    number: '04',
                    title: 'Monitoring & Evaluasi',
                    description: 'Memantau kinerja dan melakukan penyesuaian yang diperlukan.',
                  },
                  {
                    number: '05',
                    title: 'Pelaporan & Feedback',
                    description: 'Menyediakan laporan reguler dan mengumpulkan umpan balik untuk perbaikan berkelanjutan.',
                  },
                ].map((step, index) => (
                  <div key={index} className="relative flex flex-col md:flex-row items-center">
                    <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-16 text-right' : 'md:pl-16 md:order-1'}`}>
                      <div className={`bg-white p-6 rounded-lg shadow-md ${index % 2 === 0 ? 'ml-8 md:ml-0' : 'ml-8 md:ml-0'}`}>
                        <span className="text-primary-600 font-bold text-2xl">{step.number}</span>
                        <h3 className="text-xl font-bold mt-1 mb-2 text-navy-900">{step.title}</h3>
                        <p className="text-gray-600">{step.description}</p>
                      </div>
                    </div>
                    
                    <div className="absolute left-0 md:left-1/2 flex items-center justify-center">
                      <div className="w-12 h-12 rounded-full bg-primary-600 text-white flex items-center justify-center font-bold transform md:translate-x-[-50%] z-10">
                        {step.number}
                      </div>
                    </div>
                    
                    <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:order-1 md:pl-16' : 'md:pr-16 text-right'}`}></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-primary-600 text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Siap Untuk Meningkatkan Kualitas Tenaga Kerja Anda?</h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto mb-8">
            Hubungi kami sekarang untuk konsultasi gratis tentang solusi tenaga kerja terbaik untuk bisnis Anda.
          </p>
          <a
            href="/contact"
            className="btn bg-white text-primary-600 hover:bg-yellow-500 hover:text-white"
          >
            Hubungi Kami Sekarang
          </a>
        </div>
      </section>
    </>
  );
};

export default Services;